import { render, staticRenderFns } from "./FilterTypeDate.vue?vue&type=template&id=13815b2e&"
import script from "./FilterTypeDate.vue?vue&type=script&lang=js&"
export * from "./FilterTypeDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports